import { css } from "@emotion/css";
import styled from "@emotion/styled";
import React from "react";
import { useTranslation } from "react-i18next";
import { RxLoop } from "react-icons/rx";
import { GlobalState, useGlobalStateContext } from "state/GlobalState";

import Button from "./Button";

const LoopingIndicator = styled.span`
  position: absolute;
  font-size: 0.5rem;
  line-height: 0.5rem;
  font-weight: bold;
  padding: 0.15rem 0.25rem;
  background-color: var(--mi-button-text-color);
  border-radius: 100%;
  color: var(--mi-button-color);
  top: 0.2rem;
  right: 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 0.8rem;
  height: 0.8rem;
`;

export const LoopButton: React.FC = () => {
  const { t } = useTranslation("translation", { keyPrefix: "player" });
  const {
    state: { looping },
    dispatch,
  } = useGlobalStateContext();

  const onLoop = React.useCallback(() => {
    let nextLooping: GlobalState["looping"] = undefined;
    if (looping === undefined) {
      nextLooping = "loopTrack";
    } else if (looping === "loopTrack") {
      nextLooping = "loopQueue";
    }
    dispatch({ type: "setLooping", looping: nextLooping });
  }, [dispatch, looping]);

  const stateLabel = t(
    looping === "loopTrack"
      ? "loopingTrack"
      : looping === "loopQueue"
        ? "loopingQueue"
        : "loopMusic"
  );

  return (
    <>
      <Button
        buttonRole={looping ? "primary" : undefined}
        variant={looping ? "default" : "outlined"}
        aria-label={stateLabel}
        onClick={onLoop}
        startIcon={
          <>
            <RxLoop />
            {looping === "loopTrack" && <LoopingIndicator>1</LoopingIndicator>}
          </>
        }
        className={css`
          margin-left: 0.25rem;
          position: relative;
          svg {
            color: ${looping
              ? "var(--mi-button-text-color) !important"
              : "inherit"};
          }
          ${looping
            ? `color: var(--mi-button-color) !important;
             `
            : ""}
        `}
      />
      <span aria-live="polite" className="sr-only">
        {stateLabel}
      </span>
    </>
  );
};

export default LoopButton;
